import moment from 'moment';
import * as Rx from 'rxjs';
import { debounceTime, map, switchMap, take, tap } from 'rxjs/operators';
import { CustomerSearchTypes } from 'v2/interfaces/reports/interruption';
import { type SuspendChart, type SuspendFilter } from 'v2/interfaces/reports/suspend';

import apiService from '../api';

import type { ApiService } from '../api';

const today = moment().format('DD/MM/YYYY');

export const initialFilter: SuspendFilter = {
  id: '',
  date: [today, today],
  customer_type: CustomerSearchTypes.EMAIL,
  customer: '',
  product_id: [],
  invoice_id: '',
  reason_id: [],
};

export class SuspendService {
  private filters = new Rx.BehaviorSubject<SuspendFilter>(initialFilter);
  private loading = new Rx.BehaviorSubject<boolean>(true);
  private chart = new Rx.BehaviorSubject<SuspendChart>(null);

  constructor(private apiServices: ApiService) {}

  public setFilter(filter: SuspendFilter): void {
    this.loading.next(true);
    this.filters.pipe(take(1)).subscribe((currentFilter: SuspendFilter) => {
      this.filters.next({ ...currentFilter, ...filter });
    });
  }

  public isLoading = () => this.loading;
  public getFilters = (): Rx.Observable<SuspendFilter> => this.filters;
  public getChart = (): Rx.Observable<SuspendChart> => this.chart;

  public formatFilter = (filter: SuspendFilter) => {
    const [start, end] = filter.date;
    return {
      suspended_at_initial: start,
      suspended_at_final: end,
      id: filter.id || undefined,
      product_id: filter.product_id.length > 0 ? filter.product_id : undefined,
      invoice_id: filter.invoice_id || undefined,
      reason_id: filter.reason_id.length > 0 ? filter.reason_id : undefined,
      [filter.customer_type]: filter.customer ? filter.customer : undefined,
    };
  };

  public loadData() {
    return this.getFilters().pipe(
      map((filter) => this.formatFilter(filter)),
      debounceTime(10),
      switchMap((filter) => {
        this.loading.next(true);
        return this.apiServices.post('reports/subscriptions/suspension/chart', filter);
      }),
      tap((response) => {
        this.chart.next(response);
        this.loading.next(false);
      })
    );
  }

  public export() {
    return this.apiServices.download('reports/subscriptions/suspension/export', this.formatFilter(this.filters.value), {}, false, false, 'blob');
  }
}

export const suspendService = new SuspendService(apiService);
